import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Progress } from "@/components/ui/progress"
import { cn } from "@/lib/utils"
import type { Module } from "@/services/api/cronos/tracking/students/get-situation"
import Units from "../unit-list/units"

interface ModuleProps {
  modules: Module[]
}

export default function Modules({ modules }: ModuleProps) {
  if (modules.length === 0)
    return (
      <Card className="h-fit flex-1 border-none">
        <CardHeader>
          <CardTitle className="text-sm font-semibold text-foreground">
            Progreso por módulos
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">No hay módulos para mostrar</p>
        </CardContent>
      </Card>
    )

  return (
    <Card className="h-fit flex-1 border-none">
      <CardHeader>
        <CardTitle className="text-sm font-semibold text-foreground">
          Progreso por módulos
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {modules.map((m) => (
          <Accordion type="single" collapsible key={m.id}>
            <AccordionItem value={m.name} className={cn("border-none bg-transparent")}>
              <AccordionTrigger
                className={cn(
                  "flex items-center justify-between gap-2 rounded-xl bg-neutral-100 px-2.5 !no-underline",
                  "[&[data-state=open]]:border [&[data-state=open]]:border-primary-200 [&[data-state=open]]:bg-primary-100",
                )}
              >
                <span className="flex-1 text-left text-sm font-normal text-foreground">
                  {m.name}
                </span>
                <div className="inline-flex items-center gap-2">
                  <span className="text-sm font-medium text-muted-foreground">
                    {Number.isInteger(m.progress) ? m.progress : m.progress.toFixed(1)}%
                  </span>
                  <Progress
                    progressClassnames="bg-primary-500"
                    className="h-3 w-44 bg-border"
                    value={m.progress}
                  />
                </div>
              </AccordionTrigger>
              <AccordionContent className="mt-4 space-y-4 pl-8">
                <Units units={m.units} />
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        ))}
      </CardContent>
    </Card>
  )
}
